import { createSelector } from 'reselect'
import { filter, isEmpty } from 'lodash'

export const getCategories = (state) =>
  Object.values(state?.categories?.byId ?? []).filter(
    (category) => category.productType === 'Food'
  )

export const getMajorCategories = createSelector(
  getCategories,
  (categories) =>
    categories.filter((category) => category.majorCategory === true)
)

export const getMinorCategories = createSelector(
  getCategories,
  (categories) =>
    categories.filter(
      (category) =>
        category.majorCategory === false &&
        category.type === 'ItemCategory'
    )
)

export const getCategoriesIndexes = (state) =>
  state?.categories?.categoriesIndexes ?? []

export const currentCategoryItem = (state, id) =>
  state.categories.byId[id]

export const getIsCategoriesLoading = (state) =>
  state?.categories?.isLoading ?? false

export const isLoadingCategories = (state) =>
  state?.categories?.isLoading ?? false

export const getCurrentCategory = (state, uuid) =>
  state?.categories.byId[uuid] ?? {}

// modifier groups

export const getModifierGroups = (state) =>
  filter(
    state?.categories?.byId,
    (category) =>
      category.type === 'ModifierItemCategory' &&
      category.productType === 'Food'
  )

export const getHasModifierGroups = createSelector(
  getModifierGroups,
  (modifiers) => {
    return filter(modifiers, (modifier) =>
      isEmpty(modifier.secondaryPrice)
    )
  }
)

export const getSearchModifierGroupsValue = (state) =>
  state?.categories?.filters?.modifierGroups
    ?.searchModifierGroupsValue ?? ''

export const getSelectedItemsAssignedToDisplayCategory = (
  state,
  categoryId
) => {
  return (
    state?.categories?.selectedItemsAssignedToDisplayCategory[
      categoryId
    ] ?? []
  )
}
